var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8NodeJs1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 32,
    y1: 57.81,
    x2: 32,
    y2: 6.19,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18d26e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18d26e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 32,
    y1: 61.97,
    x2: 32,
    y2: 2.027,
    gradientUnits: "userSpaceOnUse",
    id: "color-2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18d26e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18d26e"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.12,33.97h-2.6c-0.2,0 -0.4,0.04 -0.58,0.11l0.02,-5.32c1.31,4.13 6.05,4.98 10.53,5.42c7.02,0.69 7.02,1.62 7.02,2.23c0,0.9 0,2.56 -5.73,2.56c-5.3,0 -6.27,-1.08 -6.65,-3.32c-0.16,-0.97 -1.02,-1.68 -2.01,-1.68zM32,6.19l-22,12.82v25.98l7.04,4.1c0.85,0.5 1.62,0.11 1.9,-0.06c0.29,-0.16 0.96,-0.65 0.96,-1.64l0.09,-27.9c0.01,-0.83 0.68,-1.5 1.51,-1.5l3,0.02c0.83,0 1.5,0.67 1.49,1.5l-0.01,4.3c1.19,-3.64 5.14,-5.81 10.89,-5.81c7.74,0 11.75,2.88 12.25,8.81c0.04,0.46 -0.12,0.93 -0.44,1.28c-0.33,0.35 -0.78,0.54 -1.24,0.54h-2.58c-0.95,0 -1.8,-0.62 -2.03,-1.54c-0.49,-2.01 -1.44,-3.08 -5.97,-3.08c-4.76,0 -4.76,1.5 -4.76,2.13c0,0.82 0,1.26 10.79,2.52c4.01,0.47 7.23,3.85 7.11,7.89c-0.16,5.3 -4.71,8.45 -12.25,8.45v-0.03c-4.86,0 -8.41,-1.09 -10.56,-3.24c-0.51,-0.51 -0.94,-1.08 -1.27,-1.69l-0.02,7.36c0,2.12 -0.82,4.08 -2.27,5.53l8.37,4.88l22,-12.82v-25.98z",
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.904,36.014c0.072,1.75 0.655,3.184 1.735,4.267c1.754,1.756 4.831,2.646 9.147,2.646v0.026c3.813,-0.005 10.168,-0.885 10.168,-6.689c0,-3.789 -2.003,-5.091 -9.315,-6.062c-6.379,-0.844 -8.585,-1.278 -8.585,-4.058c0,-4.178 5.122,-4.178 6.804,-4.178c4.962,0 7.089,1.187 7.96,4.62h2.219c-0.547,-4.521 -3.703,-6.539 -10.168,-6.539c-5.862,0 -9.224,2.267 -9.224,6.222c0,3.727 2.283,5.209 9.049,5.877c6.795,0.665 8.867,1.661 8.867,4.264c0,4.087 -4.16,4.611 -7.784,4.611c-6.276,0 -8.077,-1.752 -8.66,-5.007zM58,18.44v27.12c0,1.07 -0.57,2.06 -1.49,2.6l-23,13.4c-0.47,0.27 -0.99,0.41 -1.51,0.41c-0.52,0 -1.04,-0.14 -1.51,-0.41l-10.99,-6.4c0.83,-0.17 1.64,-0.47 2.41,-0.91h0.01l9.58,5.58c0.31,0.19 0.69,0.19 1,0l23,-13.4c0.31,-0.18 0.5,-0.51 0.5,-0.87v-27.12c0,-0.36 -0.19,-0.69 -0.5,-0.87l-23,-13.4c-0.31,-0.19 -0.69,-0.19 -1,0l-23,13.4c-0.31,0.18 -0.5,0.51 -0.5,0.87v27.12c0,0.36 0.19,0.69 0.5,0.87l3.682,2.15l3.784,2.203c1.224,0.713 2.699,0.711 3.946,-0.005c1.242,-0.714 1.984,-1.982 1.984,-3.393l0.104,-27.389l2,0.008l-0.104,27.385c0,2.131 -1.117,4.048 -2.987,5.123c-0.938,0.539 -1.962,0.808 -2.983,0.808c-1.022,0 -2.042,-0.27 -2.968,-0.81l-3.78,-2.202l-3.688,-2.148c-0.92,-0.54 -1.49,-1.53 -1.49,-2.6v-27.12c0,-1.07 0.57,-2.06 1.49,-2.6l23,-13.4c0.93,-0.55 2.09,-0.55 3.02,0l23,13.4c0.92,0.54 1.49,1.53 1.49,2.6z",
    fill: "url(#color-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8NodeJs1);
export default __webpack_public_path__ + "static/media/icons8-node-js(1).822f4f7ad57ac4615ee2b3a2e03fd2db.svg";
export { ForwardRef as ReactComponent };